"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "baronissi": {
    "0d64ea5c": [{
      "hkey": "30808355",
      "slug": "acquamela-aiello",
      "name": "Acquamela-Aiello",
      "primary": true,
      "skipSearch": false
    }],
    "acquamela": [{
      "hkey": "30808355",
      "slug": "acquamela-aiello",
      "name": "Acquamela-Aiello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ca38128f": [{
      "hkey": "30808355",
      "slug": "acquamela-aiello",
      "name": "Acquamela-Aiello",
      "primary": true,
      "skipSearch": false
    }],
    "aiello": [{
      "hkey": "30808355",
      "slug": "acquamela-aiello",
      "name": "Acquamela-Aiello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "baronissi"
    }],
    "8b2b0869": [{
      "hkey": "31326950",
      "slug": "saragnano",
      "name": "Saragnano",
      "primary": true,
      "skipSearch": false
    }],
    "caposaragnano": [{
      "hkey": "31326950",
      "slug": "saragnano",
      "name": "Saragnano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "baronissi"
    }],
    "bf68d744": [{
      "hkey": "0e4195aa",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "sava": [{
      "hkey": "0e4195aa",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "baronissi"
    }]
  }
};
exports["default"] = _default;